import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <div className=" ml-5 mt-10 ">
      <p className="flex items-center gap-3">
        <span className="text-[16px] text-gray-400">© 2025,</span>{" "}
        <NavLink
          to="/"
          className="text-[16px] text-gray-500 hover:text-[#2ca4e2] font-bold"
        >
          Fylder
        </NavLink>
      </p>
    </div>
  );
}

export default Footer;
